import {useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {message, Modal} from 'antd';
import {
  getAllPuntosVenta,
  getTypesList,
  listPuntoVenta,
  deletePuntoVentaMonitor
} from '../../redux/slices/puntosVenta';
import PuntosVentaUI from './components/PuntosVentaUI';


const PuntosVenta = () => {
  const [loading, handleLoading] = useState(true);
  const [editorVisible, handleEditorVisible] = useState(false);
  const [puntoVenta, handlePuntoVenta] = useState(null);
  const [types, handleTypes] = useState([]);
  const puntosVenta = useSelector(listPuntoVenta);
  const dispatch = useDispatch();

  const getCategories = useCallback(async () => {
    handleLoading(true);
    const [response, responseTypes] = await Promise.all([
      dispatch(getAllPuntosVenta()),
      dispatch(getTypesList()),
    ]);

    console.log("response",JSON.stringify(puntosVenta))
    if (response.status !== 'success') {
      message.error('¡Hubo un problema!');
    }
    
    if (responseTypes.status !== 'success') {
      message.error('¡Hubo un problema!');
    }else{
      const filteredTypes = responseTypes.types.filter(type => type.active === 1);
      handleTypes(filteredTypes);
    }
    handleLoading(false);
  }, [dispatch]);

  const initialFetch = useCallback(async () => {
    handleLoading(true);
    await getCategories();
    handleLoading(false);
  }, [dispatch, getCategories]);


  useEffect(() => {
    initialFetch();
  }, [initialFetch]);


  const openEditor = categoryToEdit => {
    handlePuntoVenta(categoryToEdit);
    handleEditorVisible(true);
  };

  const newCategory = () => {
    handlePuntoVenta(null);
    handleEditorVisible(true);
  };

  const closeEditor = () => {
    handlePuntoVenta(null);
    handleEditorVisible(false);
  };

  const confirmDelete = idPuntoVenta => {
    Modal.confirm({
      title: '¿Estás segúro de eliminar este punto de venta?',
      content: 'Esta información no se podrá recuperar.',
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      async onOk() {
        await removePuntoVenta(idPuntoVenta);
      },
      onCancel() {},
    });
  };

  const removePuntoVenta = async idPuntoVenta => {
    const response = await dispatch(deletePuntoVentaMonitor(idPuntoVenta));
    if (response.status !== 'success') {
      message.error('¡Hubo un problema!');
    } else {
      message.success('Categoría eliminada correctamente');
    }
  };

  return (
    <PuntosVentaUI
      loading={loading}
      puntos={puntosVenta}
      puntoVenta={puntoVenta}
      openEditor={openEditor}
      editorVisible={editorVisible}
      closeEditor={closeEditor}
      newCategory={newCategory}
      confirmDelete={confirmDelete}
      handlePuntoVenta={handlePuntoVenta}
      types={types}
    />
  );
}

export default PuntosVenta;
